export default [
  {
    key: "用户名",
    value: "Nome utente",
  },
  {
    key: "保持登录状态",
    value: "Mantieni sessione attiva",
  },
  {
    key: "咨询",
    value: "Assistenza",
  },
  {
    key: "用户",
    value: "Utente",
  },
  {
    key: "新用户?",
    value: "Nuovo utente?",
  },
  {
    key: "请输入账号",
    value: "Inserisci l'account",
  },
  {
    key: "账户名或者密码输入错误",
    value: "Nome utente o password errati",
  },
  {
    key: "请输入你的账户名称",
    value: "Inserisci il nome del tuo account",
  },
  {
    key: "城市名",
    value: "Nome della città",
  },
  {
    key: "国家名",
    value: "Nome del paese",
  },
  {
    key: "请在60秒后重新发送验证码",
    value: "Attendi 60 secondi prima di richiedere un nuovo codice",
  },
  {
    key: "个人信息确认",
    value: "Conferma dei dati personali",
  },
  {
    key: "账户注册（需要信息）",
    value: "Registrazione account (informazioni richieste)",
  },
  {
    key: "登录名",
    value: "Nome di accesso",
  },
  {
    key: "请输入NIF / DNI",
    value: "Inserisci NIF / DNI",
  },
  {
    key: "发送验证码",
    value: "Invia codice di verifica",
  },
  {
    key: "同意以上协议，进入下一步",
    value: "Accetto i termini indicati e proseguo",
  },
  {
    key: "如何注册/登录？",
    value: "Come registrarsi / accedere?",
  },
  {
    key: "密码请控制在6位以上16位以内",
    value: "La password deve contenere tra 6 e 16 caratteri",
  },
  {
    key: "注册完成",
    value: "Registrazione completata",
  },
  {
    key: "注册成功完成",
    value: "Registrazione completata con successo",
  },
  {
    key: "搜索结果有问题？",
    value: "Problemi con i risultati di ricerca?",
  },
  {
    key: "没有找到商品，请换一张图片试试",
    value: "Nessun prodotto trovato, prova con un'altra immagine",
  },
  {
    key: "登录失效",
    value: "Sessione scaduta",
  },
  {
    key: "新手导航",
    value: "Guida per principianti",
  },
  {
    key:
      "我们根据订单总额收取佣金。对于每个金额，都有特定百分比的佣金。请参阅下表，了解您的订单将对应多少百分比。",
    value:
      "Applichiamo una commissione sull'importo totale dell'ordine. Per ogni fascia di importo è prevista una percentuale specifica. Consulta la tabella seguente per la percentuale applicabile al tuo ordine.",
  },
  {
    key: "采购商品金额（欧元）",
    value: "Importo acquisto merce (EUR)",
  },
  {
    key: "国际运费说明",
    value: "Informazioni sul trasporto internazionale",
  },
  {
    key: "不含运费的产品总成本",
    value: "Costo totale prodotti (esclusa la spedizione)",
  },
  {
    key: "产品成本",
    value: "Costo del prodotto",
  },
  {
    key: "中国物流",
    value: "Logistica in Cina",
  },
  {
    key: "物流和运输",
    value: "Logistica e trasporti",
  },
  {
    key: "已驳回",
    value: "Respinto",
  },
  {
    key: "所有类别",
    value: "Tutte le categorie",
  },
  {
    key: "特色类别",
    value: "Categorie in evidenza",
  },
  {
    key: "查看更多推荐",
    value: "Vedi altri consigliati",
  },
  {
    key: "会员服务",
    value: "Servizi per i membri",
  },
  {
    key: "关于费用",
    value: "Informazioni sui costi",
  },
  {
    key: "店铺信息",
    value: "Informazioni sul negozio",
  },
  {
    key: "店铺人气商品",
    value: "Prodotti popolari del negozio",
  },
  {
    key: "进入店铺",
    value: "Entra nel negozio",
  },
  {
    key: "密码确认",
    value: "Conferma password",
  },
  {
    key: "此订单不提供运输",
    value: "Nessuna spedizione disponibile per questo ordine",
  },
  {
    key: "请输入您想搜索的产品关键字",
    value: "Inserisci le parole chiave del prodotto da cercare",
  },
  {
    key: "移出收藏夹",
    value: "Rimuovi dai preferiti",
  },
  {
    key: "产品信息",
    value: "Informazioni sul prodotto",
  },
  {
    key: "购物车商品删除成功",
    value: "Articolo rimosso dal carrello",
  },
  {
    key: "人气商品",
    value: "Prodotti popolari",
  },
  {
    key: "重新加载",
    value: "Ricarica",
  },
  {
    key: "未提出订单",
    value: "Ordini non ancora richiesti",
  },
  {
    key: "仓库",
    value: "Magazzino",
  },
  {
    key: "运费报价中",
    value: "Preventivo spedizione in elaborazione",
  },
  {
    key: "运费待付款",
    value: "Spedizione in attesa di pagamento",
  },
  {
    key: "订单日期",
    value: "Data ordine",
  },
  {
    key: "主页",
    value: "Home",
  },
  {
    key: "中国国内物流状态",
    value: "Stato logistica nazionale (Cina)",
  },
  {
    key: "发货委托",
    value: "Commessa di spedizione",
  },
  {
    key: "国际物流状态",
    value: "Stato logistica internazionale",
  },
  {
    key: "售后",
    value: "Post-vendita",
  },
  {
    key: "账户余额管理",
    value: "Gestione saldo account",
  },
  {
    key: "商品库列表",
    value: "Elenco biblioteca prodotti",
  },
  {
    key: "个人信息管理",
    value: "Gestione dati personali",
  },
  {
    key: "我的收货地址",
    value: "I miei indirizzi di consegna",
  },
  {
    key: "员工账户",
    value: "Account dipendente",
  },
  {
    key: "更改密码",
    value: "Modifica password",
  },
  {
    key: "全部订单",
    value: "Tutti gli ordini",
  },
  {
    key: "已取消",
    value: "Annullato",
  },
  {
    key: "检品中订单",
    value: "Ordini in ispezione",
  },
  {
    key: "上架完了订单",
    value: "Ordini con pubblicazione completata",
  },
  {
    key: "前往xx页",
    value: "Vai alla pagina xx",
  },
  {
    key: "提出日期",
    value: "Data richiesta",
  },
  {
    key: "购买完成日期",
    value: "Data completamento acquisto",
  },
  {
    key: "立即支付",
    value: "Paga ora",
  },
  {
    key: "问题产品明细",
    value: "Dettaglio prodotti con problemi",
  },
  {
    key: "问题照片",
    value: "Foto del problema",
  },
  {
    key: "查看照片",
    value: "Visualizza foto",
  },
  {
    key: "单价（元）",
    value: "Prezzo unitario (CNY)",
  },
  {
    key: "等待发货",
    value: "In attesa di spedizione",
  },
  {
    key: "确认签收",
    value: "Conferma ricezione",
  },
  {
    key: "单价(出入金)",
    value: "Prezzo unitario (entrata/uscita fondi)",
  },
  {
    key: "国内派送中",
    value: "Consegna nazionale in corso",
  },
  {
    key: "此订单无备注",
    value: "Nessuna nota per questo ordine",
  },
  {
    key: "可提出",
    value: "Richiedibile",
  },
  {
    key: "装箱中",
    value: "Imballaggio in corso",
  },
  {
    key: "购买数量",
    value: "Quantità acquistata",
  },
  {
    key: "可发货数量",
    value: "Quantità spedibile",
  },
  {
    key: "临时保存",
    value: "Salvato temporaneamente",
  },
  {
    key: "全部配送单",
    value: "Tutte le bolle di consegna",
  },
  {
    key: "待报价",
    value: "In attesa di preventivo",
  },
  {
    key: "待报价订单",
    value: "In attesa di preventivo",
  },
  {
    key: "等待付款(订单列表)",
    value: "In attesa di pagamento (elenco ordini)",
  },
  {
    key: "已报价",
    value: "Preventivato",
  },
  {
    key: "国际物流费用",
    value: "Costi logistica internazionale",
  },
  {
    key: "意大利国内配送中",
    value: "Consegna nazionale Italia in corso",
  },
  {
    key: "国际运输中",
    value: "Trasporto internazionale in corso",
  },
  {
    key: "已清关",
    value: "Sdoganato",
  },
  {
    key: "已签收",
    value: "Ricevuto",
  },
  {
    key: "发货时间",
    value: "Ora di spedizione",
  },
  {
    key: "去提现",
    value: "Vai al prelievo",
  },
  {
    key: "剩余可用点数",
    value: "Punti disponibili rimanenti",
  },
  {
    key: "已充值待确认点数",
    value: "Punti ricaricati in attesa di conferma",
  },
  {
    key: "提现中",
    value: "Prelievo in corso",
  },
  {
    key: "公司名称",
    value: "Ragione sociale",
  },
  {
    key: "你的商业网站(非强制性)",
    value: "Sito web aziendale (facoltativo)",
  },
  {
    key: "公司地址",
    value: "Indirizzo aziendale",
  },
  {
    key: "公司营业执照",
    value: "Licenza commerciale / visura aziendale",
  },
  {
    key: "SWIFT账户",
    value: "Conto SWIFT",
  },
  {
    key: "提现申请信息",
    value: "Dati richiesta di prelievo",
  },
  {
    key: "当前账户余额",
    value: "Saldo attuale dell'account",
  },
  {
    key: "户名",
    value: "Intestatario del conto",
  },
  {
    key: "请输入户名",
    value: "Inserisci l'intestatario",
  },
  {
    key: "提现金额",
    value: "Importo del prelievo",
  },
  {
    key: "提现申请原因",
    value: "Motivo della richiesta di prelievo",
  },
  {
    key: "确认提交",
    value: "Conferma invio",
  },
  {
    key: "请输入公司名称",
    value: "Inserisci la ragione sociale",
  },
  {
    key: "请输入公司网址",
    value: "Inserisci il sito web aziendale",
  },
  {
    key: "请输入银行账户",
    value: "Inserisci le coordinate bancarie",
  },
  {
    key: "请输入提现金额",
    value: "Inserisci l'importo del prelievo",
  },
  {
    key: "请输入提现申请原因",
    value: "Inserisci il motivo della richiesta di prelievo",
  },
  {
    key: "请您核对以下信息是否正确",
    value: "Verificare che le seguenti informazioni siano corrette",
  },
  {
    key: "汇款取款历史",
    value: "Storico bonifici e prelievi",
  },
  {
    key: "日期（财务确认日期）",
    value: "Data (data di conferma amministrativa)",
  },
  {
    key: "交易类型",
    value: "Tipo di transazione",
  },
  {
    key: "收支",
    value: "Entrate e uscite",
  },
  {
    key: "配送单",
    value: "Bolla di consegna",
  },
  {
    key: "提现记录",
    value: "Registro prelievi",
  },
  {
    key: "此配送单已正式提出，请勿重复操作",
    value:
      "Questa bolla è già stata formalmente richiesta, non ripetere l'operazione",
  },
  {
    key: "发起时间",
    value: "Ora di avvio",
  },
  {
    key: "流水号",
    value: "Numero di riferimento / progressivo",
  },
  {
    key: "收款户名",
    value: "Intestatario del beneficiario",
  },
  {
    key: "收款户号",
    value: "Conto del beneficiario",
  },
  {
    key: "处理状态",
    value: "Stato di elaborazione",
  },
  {
    key: "待审核",
    value: "In attesa di approvazione",
  },
  {
    key: "查看凭证",
    value: "Visualizza ricevuta / prova",
  },
  {
    key: "人工调整",
    value: "Rettifica manuale",
  },
  {
    key: "已被停用",
    value: "Disattivato",
  },
  {
    key: "是否删除选中的配送单？",
    value: "Eliminare le bolle selezionate?",
  },
  {
    key: "商品编号",
    value: "Codice articolo",
  },
  {
    key: "英文产品名称",
    value: "Nome prodotto in inglese",
  },
  {
    key: "提出订单",
    value: "Richiedi ordine",
  },
  {
    key: "商品备注详情",
    value: "Dettaglio note sul prodotto",
  },
  {
    key: "请输入备注信息",
    value: "Inserisci le note",
  },
  {
    key: "修改地址",
    value: "Modifica indirizzo",
  },
  {
    key: "意大利派送",
    value: "Consegna in Italia",
  },
  {
    key: "国际追踪号码",
    value: "Numero di tracking internazionale",
  },
  {
    key: "到达RAKUMART物流中心",
    value: "Arrivato al centro logistico RAKUMART",
  },
  {
    key: "已发出的订单",
    value: "Ordini già spediti",
  },
  {
    key: "已到达RAKUMART仓库的订单",
    value: "Ordini arrivati in magazzino RAKUMART",
  },
  {
    key: "待支付国际运费的订单",
    value: "Ordini in attesa del pagamento della spedizione internazionale",
  },
  {
    key: "临时保存的",
    value: "Salvati temporaneamente",
  },
  {
    key: "出货完成",
    value: "Spedizione completata",
  },
  {
    key: "确认关闭",
    value: "Conferma chiusura",
  },
  {
    key: "格式不正确",
    value: "Formato non valido",
  },
  {
    key: "同步到收件人",
    value: "Sincronizza con il destinatario",
  },
  {
    key: "请输入旧登录密码",
    value: "Inserisci la vecchia password di accesso",
  },
  {
    key: "密码修改成功，请重新登录",
    value: "Password modificata con successo, accedi di nuovo",
  },
  {
    key: "当前未登录",
    value: "Non connesso",
  },
  {
    key: "未付款订单",
    value: "Ordini non pagati",
  },
  {
    key: "你的主要业务领域",
    value: "Il tuo settore principale di attività",
  },
  {
    key: "店铺名/店铺",
    value: "Nome negozio / Negozio",
  },
  {
    key: "选择附加服务",
    value: "Seleziona servizi aggiuntivi",
  },
  {
    key: "追加商品",
    value: "Aggiungi articoli",
  },
  {
    key: "客户提现出金",
    value: "Prelievo cliente (uscita fondi)",
  },
  {
    key: "客户提出现金",
    value: "Prelievo contanti cliente",
  },
  {
    key: "全部费用",
    value: "Tutti i costi",
  },
  {
    key: "体积m³",
    value: "Volume (m³)",
  },
  {
    key: "立方米体积",
    value: "Volume in metri cubi",
  },
  {
    key: "附加服务费",
    value: "Costi servizio aggiuntivo",
  },
  {
    key: "选择国际运输公司",
    value: "Seleziona vettore internazionale",
  },
  {
    key: "请选择您的物流方式，不同的物流方式价格不同",
    value:
      "Seleziona il metodo di spedizione: prezzi diversi in base al corriere",
  },
  {
    key: "特殊要求备注",
    value: "Note per richieste speciali",
  },
  {
    key: "对该订单有特殊要求的，可以在这边备注",
    value: "Per richieste speciali sull'ordine, indica qui le note",
  },
  {
    key: "备注后会同步显示给业务员",
    value: "Le note saranno visibili anche all'addetto commerciale",
  },
  {
    key: "附加服务选项",
    value: "Opzioni servizi aggiuntivi",
  },
  {
    key: "内容",
    value: "Contenuto",
  },
  {
    key: "人民币",
    value: "Yuan cinese (CNY)",
  },
  {
    key: "收件工资",
    value: "Compensi ricezione",
  },
  {
    key: "唛头",
    value: "Marchio di spedizione / contrassegno",
  },
  {
    key: "联系我们",
    value: "Contattaci",
  },
  {
    key: "该订单已正式提出，勿重复提出",
    value: "Ordine già formalmente richiesto, non ripetere la richiesta",
  },
  {
    key: "预估到手费用",
    value: "Costo stimato a destinazione finale",
  },
  {
    key: "特殊备注要求",
    value: "Note speciali richieste",
  },
  {
    key: "使用优惠券",
    value: "Usa coupon",
  },
  {
    key: "全部费用明细",
    value: "Dettaglio di tutti i costi",
  },
  {
    key: "修改订单",
    value: "Modifica ordine",
  },
  {
    key: "查看全部",
    value: "Visualizza tutto",
  },
  {
    key: "业务给客户的回复",
    value: "Risposta commerciale al cliente",
  },
  {
    key: "RAKUMART订单价值",
    value: "Valore ordine RAKUMART",
  },
  {
    key: "调查单价",
    value: "Prezzo unitario indagine",
  },
  {
    key: "免手续费、无佣金",
    value: "Senza commissioni né spese di gestione",
  },
  {
    key: "已使用优惠",
    value: "Sconto già utilizzato",
  },
  {
    key: "余额支付",
    value: "Pagamento con saldo",
  },
  {
    key: "支付成功",
    value: "Pagamento riuscito",
  },
  {
    key: "是否使用余额支付",
    value: "Pagare con il saldo?",
  },
  {
    key: "财务部门将确认您提交的付款。财务确认后，充值金额将反映在账户余额中",
    value:
      "L'amministrazione confermerà il pagamento inviato. Dopo la conferma, l'importo ricaricato sarà visibile sul saldo del conto.",
  },
  {
    key: "付款流水号",
    value: "Riferimento pagamento",
  },
  {
    key: "回到个人中心",
    value: "Torna all'area personale",
  },
  {
    key: "中国总成本",
    value: "Costo totale Cina",
  },
  {
    key: "中国国内运费",
    value: "Spedizione nazionale in Cina",
  },
  {
    key: "费率",
    value: "Tasso / percentuale",
  },
  {
    key: "预计成本",
    value: "Costo stimato",
  },
  {
    key: "意大利物流成本",
    value: "Costi logistica Italia",
  },
  {
    key: "税金",
    value: "Imposte",
  },
  {
    key: "目的地",
    value: "Destinazione",
  },
  {
    key: "航运标志",
    value: "Marchio di navigazione",
  },
  {
    key: "表格下载",
    value: "Scarica tabella",
  },
  {
    key: "形式发票",
    value: "Fattura proforma",
  },
  {
    key: "销售合同",
    value: "Contratto di vendita",
  },
  {
    key: "全选/取消",
    value: "Seleziona tutto / Annulla selezione",
  },
  {
    key: "支付金额",
    value: "Importo da pagare",
  },
  {
    key: "估计产品进口详情",
    value: "Dettaglio stimato importazione prodotto",
  },
  {
    key: "费用明细",
    value: "Dettaglio costi",
  },
  {
    key: "重量",
    value: "Peso",
  },
  {
    key: "单番合计",
    value: "Totale per voce / lotto",
  },
  {
    key: "订单",
    value: "Ordine",
  },
  {
    key: "国内物流状态",
    value: "Stato logistica nazionale",
  },
  {
    key: "账户",
    value: "Account",
  },
  {
    key: "问题商品",
    value: "Prodotti con problemi",
  },
  {
    key: "关于公司",
    value: "Chi siamo",
  },
  {
    key: "公司介绍",
    value: "Presentazione aziendale",
  },
  {
    key: "会员服务条款",
    value: "Termini del servizio per i membri",
  },
  {
    key: "隐私政策",
    value: "Informativa sulla privacy",
  },
  {
    key: "表格",
    value: "Tabella",
  },
  {
    key: "物流与运输",
    value: "Logistica e trasporti",
  },
  {
    key: "已付款待财务确认",
    value: "Pagato, in attesa di conferma amministrativa",
  },
  {
    key: "全部的费用",
    value: "Tutti i costi",
  },
  {
    key: "国际物流预估",
    value: "Stima logistica internazionale",
  },
  {
    key: "意大利物流预估",
    value: "Stima logistica Italia",
  },
  {
    key: "运输产品的总成本",
    value: "Costo totale trasporto prodotti",
  },
  {
    key: "增值税预估",
    value: "Stima IVA",
  },
  {
    key: "意大利预估",
    value: "Stima per l'Italia",
  },
  {
    key: "全部费用预估",
    value: "Stima costi totali",
  },
  {
    key: "负责人回复",
    value: "Risposta del referente",
  },
  {
    key: "国际船运A",
    value: "Trasporto marittimo internazionale A",
  },
  {
    key: "可提货数量",
    value: "Quantità ritirabile",
  },
  {
    key: "已提货数量",
    value: "Quantità già ritirata",
  },
  {
    key: "计费数据",
    value: "Dati di fatturazione",
  },
  {
    key: "提示：配送单信息如有修改，请联系您的负责人员",
    value: "Nota: in caso di modifiche alla bolla, contatta il tuo referente",
  },
  {
    key: "提出数",
    value: "Quantità richiesta",
  },
  {
    key: "请输入CNPJ",
    value: "Inserisci CNPJ",
  },
  {
    key: "提示文字",
    value: "Testo guida",
  },
  {
    key: "提交",
    value: "Invia",
  },
  {
    key: "汇款图片不能为空",
    value: "L'immagine del bonifico non può essere vuota",
  },
  {
    key: "待处理",
    value: "In elaborazione",
  },
  {
    key: "日期",
    value: "Data",
  },
  {
    key: "余额",
    value: "Saldo",
  },
  {
    key: "确认修改",
    value: "Conferma modifiche",
  },
  {
    key: "邮箱地址",
    value: "Indirizzo e-mail",
  },
  {
    key: "预计订单金额",
    value: "Importo ordine stimato",
  },
  {
    key: "付款后账户剩余",
    value: "Saldo residuo dopo il pagamento",
  },
  {
    key: "请选择国家",
    value: "Seleziona il paese",
  },
  {
    key: "请填写确认码",
    value: "Inserisci il codice di conferma",
  },
  {
    key: "需要信息",
    value: "Informazioni richieste",
  },
  {
    key: "意大利",
    value: "Italia",
  },
  {
    key: "请输入验证码",
    value: "Inserisci il codice di verifica",
  },
  {
    key: "请输入登录名",
    value: "Inserisci il nome di accesso",
  },
  {
    key: "返回重新编辑",
    value: "Torna per modificare",
  },
  {
    key: "暂无库存",
    value: "Non disponibile in magazzino",
  },
  {
    key: "秒后可重新发送验证码",
    value: "secondi prima di poter rinviare il codice",
  },
  {
    key: "费用(€)",
    value: "Costo (€)",
  },
  {
    key: "箱号",
    value: "Numero collo",
  },
  {
    key: "实际重量",
    value: "Peso effettivo",
  },
  {
    key: "长",
    value: "Lunghezza",
  },
  {
    key: "宽",
    value: "Larghezza",
  },
  {
    key: "当前箱号",
    value: "Collo corrente",
  },
  {
    key: "番号",
    value: "Numero riga / lotto",
  },
  {
    key: "图片",
    value: "Immagine",
  },
  {
    key: "该商品本箱装箱数",
    value: "Quantità di questo articolo in questo collo",
  },
  {
    key: "已付款待确认",
    value: "Pagato, in attesa di conferma",
  },
  {
    key: "欢迎光临Rakumart",
    value: "Benvenuto su Rakumart",
  },
  {
    key: "去商店",
    value: "Vai al negozio",
  },
  {
    key: "是否提交充值信息？",
    value: "Inviare le informazioni di ricarica?",
  },
  {
    key: "清关时间",
    value: "Tempi di sdoganamento",
  },
  {
    key: "意大利物流发货时间",
    value: "Data spedizione logistica Italia",
  },
  {
    key: "已删除",
    value: "Eliminato",
  },
  {
    key: "装箱信息",
    value: "Informazioni imballo",
  },
  {
    key: "单番中国所有费用",
    value: "Tutti i costi Cina per voce",
  },
  {
    key: "预计订单总运费:",
    value: "Spedizione totale stimata dell'ordine:",
  },
  {
    key:
      "温馨提示：每笔订单只能使用一张同类型的优惠券，不同类型的优惠券可以多张同时使用",
    value:
      "Nota: per ogni ordine è possibile usare un solo coupon dello stesso tipo; tipi diversi possono essere combinati.",
  },
  {
    key: "汇款金额不能小于订单金额",
    value:
      "L'importo del bonifico non può essere inferiore all'importo dell'ordine",
  },
  {
    key: "总成本",
    value: "Costo totale",
  },
  {
    key:
      "*根据期间限定打折价格和批量价格变化的情况下，有在RAKUMART不正确显示的情况，不过，因为估价完成时被修正，请直接提交估价。",
    value:
      "*In caso di prezzi promozionali o sconti quantità, RAKUMART potrebbe mostrare importi non corretti; al completamento del preventivo i valori vengono corretti: invia pure il preventivo.",
  },
  {
    key: "初学者指南",
    value: "Guida per principianti",
  },
  {
    key: "中国所有费用",
    value: "Tutti i costi in Cina",
  },
  {
    key: "反倾销税预估",
    value: "Stima dazi antidumping",
  },
  {
    key: "预计总成本",
    value: "Costo totale stimato",
  },
  {
    key: "费用总计",
    value: "Totale costi",
  },
  {
    key: "确认关闭?",
    value: "Confermi la chiusura?",
  },
  {
    key: "高",
    value: "Alto",
  },
  {
    key: "摄影",
    value: "Fotografia",
  },
  {
    key: "摄影服务",
    value: "Servizio fotografico",
  },
  {
    key: "贴条形码",
    value: "Applicazione codice a barre",
  },
  {
    key: "配套",
    value: "Kit / set",
  },
  {
    key: "取布标",
    value: "Rimozione etichetta tessuto",
  },
  {
    key: "缝布标",
    value: "Cucitura etichetta tessuto",
  },
  {
    key: "挂吊牌",
    value: "Applicazione cartellino",
  },
  {
    key: "取吊牌",
    value: "Rimozione cartellino",
  },
  {
    key: "更换OPP袋",
    value: "Sostituzione busta OPP",
  },
  {
    key: "气泡膜包装",
    value: "Imballaggio a bolle d'aria",
  },
  {
    key: "单面印刷",
    value: "Stampa su un lato",
  },
  {
    key: "双面印刷",
    value: "Stampa fronte-retro",
  },
  {
    key: "金额变动明细",
    value: "Dettaglio variazioni importo",
  },
  {
    key: "元/个",
    value: "CNY/pezzo",
  },
  {
    key: "元/张",
    value: "CNY/foglio",
  },
  {
    key: "点击查看详情",
    value: "Clicca per i dettagli",
  },
  {
    key: "包括装OPP袋或者换OPP袋",
    value: "Include imballaggio in busta OPP o sostituzione busta OPP",
  },
  {
    key: "4种商品以上配套手续费另行商谈",
    value: "Oltre 4 tipi di prodotto nel kit: tariffe da concordare",
  },
  {
    key: "请参照右侧图片",
    value: "Consulta l'immagine a destra",
  },
  {
    key: "默认为A4纸张，其它类型纸张或小册子印刷请另行商谈",
    value: "Predefinito formato A4; altri formati o opuscoli da concordare",
  },
  {
    key: "默认到货商品检查项目",
    value: "Controlli standard alla ricezione merce",
  },
  {
    key: "产品是否按订单发货",
    value: "La merce corrisponde all'ordine?",
  },
  {
    key: "外观有无损坏",
    value: "Danni estetici o esterni",
  },
  {
    key: "产品页面与产品是否存在较大差异？",
    value: "Grandi differenze tra pagina prodotto e merce ricevuta?",
  },
  {
    key:
      "我们将针对到货的商品主要针对以上三点进行检查，问题的商品，我们将向客户反馈。",
    value:
      "All'arrivo controlleremo la merce secondo questi tre punti; in caso di problemi informeremo il cliente.",
  },
  {
    key: "大件商品请另行商谈",
    value: "Merci ingombranti: da concordare separatamente",
  },
  {
    key: "操作内容",
    value: "Contenuto dell'operazione",
  },
  {
    key:
      "系统将根据您在本网站上累计出货的商品金额来决定手续费等级。不同的已出货的商品金额，对应着不同的会员等级。详情请参考下面的表格明细。",
    value:
      "Il livello di commissione dipende dall'importo cumulativo spedito tramite il sito. Importi diversi corrispondono a livelli di membership diversi. Vedi la tabella seguente per i dettagli.",
  },
  {
    key:
      "例如：您累计出货的商品金额超过50,000欧元，您之后再下的订单手续费比例将变为9％。",
    value:
      "Esempio: superati 50.000 € di merce spedita in accumulo, la percentuale di commissione sugli ordini successivi diventa il 9%.",
  },
  {
    key: "采购商品金额",
    value: "Importo acquisto merce",
  },
  {
    key: "已通关",
    value: "Sdoganamento completato",
  },
  {
    key: "商品调整",
    value: "Rettifica articoli",
  },
  {
    key: "已收货并检品完成",
    value: "Ricevuto e ispezione completata",
  },
  {
    key: "已打款",
    value: "Bonifico effettuato",
  },
  {
    key: "是否同步到进口商",
    value: "Sincronizzare con l'importatore?",
  },
  {
    key: "是否同步到收件人",
    value: "Sincronizzare con il destinatario?",
  },
  {
    key: "该订单状态不可支付",
    value: "Impossibile pagare in questo stato dell'ordine",
  },
  {
    key: "该配送单状态不可支付",
    value: "Impossibile pagare in questo stato della bolla",
  },
  {
    key: "为编辑",
    value: "Da modificare",
  },
  {
    key: "自动签收时间",
    value: "Ricezione automatica (tempo)",
  },
  {
    key: "访问",
    value: "Visita",
  },
  {
    key: "可用",
    value: "Disponibile",
  },
  {
    key: "过期",
    value: "Scaduto",
  },
  {
    key: "店铺加载中",
    value: "Caricamento negozio in corso",
  },
  {
    key: "未查找到该账号，请核对后再尝试或联系客服处理",
    value: "Account non trovato: verifica i dati o contatta l'assistenza",
  },
  {
    key: "发票上传",
    value: "Carica fattura",
  },
  {
    key: "已发货",
    value: "Spedito",
  },
  {
    key: "RAKUMART商品采购服务的描述",
    value: "Descrizione del servizio di acquisto prodotti RAKUMART",
  },
  {
    key: "通用操作程序的描述",
    value: "Descrizione delle procedure operative generali",
  },
  {
    key: "客户个人中心的功能描述",
    value: "Descrizione delle funzioni dell'area personale cliente",
  },
  {
    key: "账户余额不足",
    value: "Saldo insufficiente",
  },
  {
    key: "客户提现",
    value: "Prelievo cliente",
  },
  {
    key: "意大利物流单号",
    value: "Tracking logistica Italia",
  },
  {
    key: "意大利物流方式",
    value: "Metodo di spedizione in Italia",
  },
  {
    key: "签收",
    value: "Ricezione / consegna",
  },
  {
    key: "最低汇款金额",
    value: "Importo minimo di bonifico",
  },
  {
    key: "注册帐户",
    value: "Registra account",
  },
  {
    key: "搜索产品",
    value: "Cerca prodotti",
  },
  {
    key: "如何下订单",
    value: "Come effettuare un ordine",
  },
  {
    key: "如何提交交付请求",
    value: "Come inviare una richiesta di consegna",
  },
  {
    key: "修改订单和交货订单",
    value: "Modifica ordine e bolle di consegna",
  },
  {
    key: "发票生成失败，请检查您是否有默认地址，如无法解决，请直接联系负责人",
    value:
      "Generazione fattura non riuscita: verifica di avere un indirizzo predefinito; in caso di problemi contatta il referente",
  },
  {
    key: "资本项目",
    value: "Voci di capitale",
  },
  {
    key: "最喜欢的",
    value: "Preferiti",
  },
  {
    key: "个人数据",
    value: "Dati personali",
  },
  {
    key: "国家运输",
    value: "Trasporto nazionale",
  },
  {
    key: "与费用支付有关的问题",
    value: "Domande su pagamenti e commissioni",
  },
  {
    key: "货物运输的清关问题",
    value: "Sdoganamento delle merci",
  },
  {
    key: "关于商店和产品",
    value: "Negozio e prodotti",
  },
  {
    key: "货物的售后加工",
    value: "Post-vendita sulle merci",
  },
  {
    key: "规则协议",
    value: "Regole e accordi",
  },
  {
    key: "意大利国内物流",
    value: "Logistica nazionale in Italia",
  },
  {
    key: "国际物流",
    value: "Logistica internazionale",
  },
  {
    key: "免手续费-1次",
    value: "Nessuna commissione – 1 volta",
  },
  {
    key: "提交失败",
    value: "Invio non riuscito",
  },
  {
    key: "提现成功",
    value: "Prelievo completato con successo",
  },
  {
    key: "国际运费模拟",
    value: "Simulazione costi spedizione internazionale",
  },
  {
    key: "估计物流成本",
    value: "Costo logistico stimato",
  },
  {
    key: "估计重量(KG)",
    value: "Peso stimato (kg)",
  },
  {
    key: "预计商品总体积（m³）",
    value: "Volume totale stimato delle merci (m³)",
  },
  {
    key: "重新输入",
    value: "Reinserisci",
  },
  {
    key: "计算",
    value: "Calcola",
  },
  {
    key: "预计国际运费:",
    value: "Spedizione internazionale stimata:",
  },
  {
    key: "预计总物流成本:",
    value: "Costo logistico totale stimato:",
  },
  {
    key: "税号/身份证号",
    value: "Partita IVA / codice fiscale",
  },
  {
    key: "在意大利的估计运费:",
    value: "Spedizione stimata in Italia:",
  },
  {
    key: "提出数量不能小于1",
    value: "La quantità richiesta non può essere inferiore a 1",
  },
  {
    key: "公司",
    value: "Azienda",
  },
  {
    key: "法律条件",
    value: "Condizioni legali",
  },
  {
    key: "支持",
    value: "Supporto",
  },
  {
    key: "订单跟踪",
    value: "Tracciamento ordine",
  },
  {
    key: "信息和费率",
    value: "Informazioni e tariffe",
  },
  {
    key: "费用和佣金",
    value: "Costi e commissioni",
  },
  {
    key: "退货和退款",
    value: "Resi e rimborsi",
  },
  {
    key: "会员服务(页脚)",
    value: "Servizi per i membri (piè di pagina)",
  },
  {
    key: "摄影服务(页脚)",
    value: "Servizio fotografico (piè di pagina)",
  },
  {
    key: "其他",
    value: "Altro",
  },
  {
    key: "选择行业",
    value: "Seleziona il settore",
  },
  {
    key: "查看更多类别",
    value: "Vedi altre categorie",
  },
  {
    key: "您在订单中要求的服务或特殊要求",
    value: "Servizi o richieste speciali indicate nell'ordine",
  },
  {
    key: "如果您有任何问题，请通过RakuChat与专家代理联系。",
    value: "Per qualsiasi domanda contatta tramite RakuChat un agente esperto.",
  },
  {
    key: "特殊要求的意见和备注",
    value: "Commenti e note per richieste speciali",
  },
  {
    key: "写下你的产品需要什么额外的服务或特殊要求",
    value:
      "Descrivi quali servizi extra o richieste speciali servono al tuo prodotto",
  },
  {
    key: "例如:-定制包装，-产品定制…",
    value: "Esempio: imballaggio su misura, personalizzazione del prodotto…",
  },
  {
    key: "一位经验丰富的代理将与您联系以确定细节",
    value: "Un agente esperto ti contatterà per definire i dettagli",
  },
  {
    key: "产品费用细目",
    value: "Dettaglio costi prodotto",
  },
  {
    key: "估计运费",
    value: "Spedizione stimata",
  },
  {
    key: "估计总进口成本(包括物流和税收)的成本细目",
    value:
      "Dettaglio del costo totale di importazione stimato (logistica e imposte)",
  },
  {
    key: "估计国际运输",
    value: "Trasporto internazionale stimato",
  },
  {
    key: "对意大利的估计",
    value: "Stima per l'Italia",
  },
  {
    key: "反倾销关税",
    value: "Dazi antidumping",
  },
  {
    key: "估计反倾销税",
    value: "Stima dazi antidumping",
  },
  {
    key: "估计增值税",
    value: "Stima IVA",
  },
  {
    key: "估计总开支",
    value: "Spesa totale stimata",
  },
  {
    key: "运费什么时候付款?",
    value: "Quando si paga la spedizione?",
  },
  {
    key:
      "为了支付你的产品，在我们给你一个估计的运输报价之前，我们必须知道你的订单中包含的项目是否受到进出口限制，工厂的可用性，尺寸，产品的确切重量，等等。",
    value:
      "Per pagare i prodotti e ricevere un preventivo di spedizione stimato, dobbiamo sapere se gli articoli sono soggetti a restrizioni all'import/export, disponibilità in fabbrica, dimensioni, peso esatto, ecc.",
  },
  {
    key:
      "谢谢你。您的订单细节已正确确认。在不到24小时内，您将收到一封电子邮件，详细说明可能的运输方式的估计运输费用。",
    value:
      "Grazie. I dettagli del tuo ordine sono stati confermati. Entro 24 ore riceverai un'e-mail con le spese di spedizione stimate per i possibili corrieri.",
  },
  {
    key: "产品不可用",
    value: "Prodotto non disponibile",
  },
  {
    key: "替代产品",
    value: "Prodotto alternativo",
  },
  {
    key: "正在进行的报价",
    value: "Preventivo in corso",
  },
  {
    key: "谢谢你。您的请求细节已成功确认。",
    value:
      "Grazie. I dettagli della richiesta sono stati confermati con successo.",
  },
  {
    key:
      "在不到24小时内，您将收到一封电子邮件，其中包含产品付款的详细信息和可能的运输方式的估计运费。",
    value:
      "Entro 24 ore riceverai un'e-mail con i dettagli di pagamento del prodotto e le spese di spedizione stimate per i possibili corrieri.",
  },
  {
    key:
      "为了提供一个估计的运输报价，我们必须知道产品的尺寸和确切的重量。这就是为什么我们联系制造商，并计算您的订单的估计运输成本。",
    value:
      "Per un preventivo di spedizione stimato servono dimensioni e peso esatti del prodotto: contattiamo il produttore e calcoliamo il costo di trasporto stimato dell'ordine.",
  },
  {
    key: "我们联系制造商要求必要的信息，并能够估计产品的运输成本。",
    value:
      "Contattiamo il produttore per le informazioni necessarie e per stimare il costo di trasporto del prodotto.",
  },
  {
    key: "产品的付款",
    value: "Pagamento prodotti",
  },
  {
    key: "一旦知道估计的运输成本，您可以正式购买您的订单的产品。",
    value:
      "Noto il costo di spedizione stimato, puoi acquistare formalmente i prodotti dell'ordine.",
  },
  {
    key: "为什么装运是估计的?",
    value: "Perché la spedizione è stimata?",
  },
  {
    key: "银行卡进行付款",
    value: "Pagamento con carta bancaria",
  },
  {
    key: "Redsys Santander支付网关",
    value: "Gateway di pagamento Redsys Santander",
  },
  {
    key: "Redsys",
    value: "Redsys",
  },
  {
    key: "您将被重定向到Redsys Santander支付网关",
    value: "Verrai reindirizzato al gateway di pagamento Redsys Santander",
  },
  {
    key: "优势",
    value: "Vantaggi",
  },
  {
    key: "如何工作",
    value: "Come funziona",
  },
  {
    key: "感谢您的注册!现在你可以开始享受Rakumart提供的所有好处了。",
    value:
      "Grazie per la registrazione! Ora puoi iniziare a usufruire di tutti i vantaggi di Rakumart.",
  },
  {
    key: "我知道并同意本网站的隐私政策条款和条件。",
    value:
      "Dichiaro di conoscere e accettare l'informativa sulla privacy e i termini e condizioni del sito.",
  },
  {
    key: "订单成功完成",
    value: "Ordine completato con successo",
  },
  {
    key: "接下来是什么?",
    value: "E adesso?",
  },
  {
    key: "国际航运的最终报价",
    value: "Preventivo definitivo della spedizione internazionale",
  },
  {
    key: "进口总成本细目(包括物流和税收)",
    value: "Dettaglio del costo totale di importazione (logistica e imposte)",
  },
  {
    key: "应付总额",
    value: "Totale da pagare",
  },
  {
    key: "库存数量不足",
    value: "Quantità in magazzino insufficiente",
  },
  {
    key: "购买中",
    value: "Acquisto in corso",
  },
  {
    key: "提出数量不能大于可提出数",
    value: "La quantità richiesta non può superare la quantità richiedibile",
  },
  {
    key: "请在以下字段填写您的信息。",
    value: "Compila i campi seguenti con i tuoi dati.",
  },
  {
    key: "所有字段都是必需的。",
    value: "Tutti i campi sono obbligatori.",
  },
  {
    key: "已经有账户了?登录",
    value: "Hai già un account? Accedi",
  },
  {
    key: "颜色",
    value: "Colore",
  },
  {
    key: "请输入CIF/NIF",
    value: "Inserisci CIF/NIF",
  },
  {
    key: "数据获取错误",
    value: "Errore nel recupero dei dati",
  },
  {
    key: "我是特别的",
    value: "Sono speciale",
  },
  {
    key: "看来我们找不到你要找的东西。",
    value: "Sembra che non riusciamo a trovare ciò che cerchi.",
  },
  {
    key: "你的搜索结果是",
    value: "I risultati della tua ricerca sono",
  },
  {
    key: "这个订单的数量很少，请注意：",
    value: "Attenzione: quantità molto bassa per questo ordine:",
  },
  {
    key:
      "谢谢。您的请求细节已经确认无误。在不到24小时内，您将收到一封电子邮件，其中包括订单产品的报价和支付细节。您还将收到可能的运输方法的预估运费报价。",
    value:
      "Grazie. I dettagli della richiesta sono confermati. Entro 24 ore riceverai un'e-mail con preventivo e dettagli di pagamento dei prodotti dell'ordine, oltre al preventivo di spedizione per i possibili metodi.",
  },
  {
    key: "预估的运费报价。提示信息。可用的运输方式。取决于订单的特征。",
    value:
      "Preventivo di spedizione stimato, messaggi informativi e metodi disponibili dipendono dalle caratteristiche dell'ordine.",
  },
  {
    key: "什么时候付款?",
    value: "Quando pagare?",
  },
  {
    key: "专业买家和公司免费注册",
    value: "Registrazione gratuita per buyer professionisti e aziende",
  },
  {
    key: "在以下字段中填写您的业务或公司信息:",
    value: "Compila nei campi seguenti i dati della tua attività o azienda:",
  },
  {
    key: "我们建议您花几分钟时间了解更多关于Rakumart的信息:",
    value:
      "Ti consigliamo di dedicare qualche minuto a saperne di più su Rakumart:",
  },
  {
    key: "Rakumart是做什么的?",
    value: "Cosa fa Rakumart?",
  },
  {
    key: "Rakumart的优势是什么?",
    value: "Quali sono i vantaggi di Rakumart?",
  },
  {
    key: "估计总进口费用的成本细目。",
    value: "Dettaglio del costo totale di importazione stimato.",
  },
  {
    key: "总产量",
    value: "Produzione totale",
  },
  {
    key: "图形验证码错误",
    value: "Errore nel captcha grafico",
  },
  {
    key: "刷新",
    value: "Aggiorna",
  },
  {
    key: "图形验证码缺失",
    value: "Captcha grafico mancante",
  },
  {
    key: "输入您公司或企业所在的城市/人口",
    value: "Inserisci la città o il comune della sede aziendale",
  },
  {
    key: "严选工厂",
    value: "Fabbriche selezionate",
  },
  {
    key: "分类",
    value: "Categoria",
  },
  {
    key: "否",
    value: "No",
  },
  {
    key: "是",
    value: "Sì",
  },
  {
    key: "CE认证",
    value: "Certificazione CE",
  },
  {
    key: "加入我们由数千名进口商组成的社区，并开始使用Rakumart智能进口!",
    value:
      "Unisciti alla nostra community di migliaia di importatori e inizia a importare in modo intelligente con Rakumart!",
  },
  {
    key: "我们很高兴能在一起!",
    value: "Siamo felici di averti con noi!",
  },
  {
    key: "输入您的企业网站",
    value: "Inserisci il sito web della tua azienda",
  },
  {
    key: "Streetwear",
    value: "Streetwear",
  },
  {
    key: "的未来",
    value: "Il futuro",
  },
  {
    key: "警告：点击这里展开或收缩所有框",
    value: "Attenzione: clicca qui per espandere o comprimere tutti i riquadri",
  },
  {
    key: "内容订购详细信息",
    value: "Dettagli contenuto ordine",
  },
  {
    key: "订购内容",
    value: "Contenuto ordine",
  },
  {
    key: "在中国的总成本",
    value: "Costo totale in Cina",
  },
  {
    key: "复制失败",
    value: "Copia non riuscita",
  },
];
